import { Route, Routes } from "react-router-dom";
import CreateServiceOrder from "../../pages/service-orders/create-service-order-page";
import UpdateServiceOrder from "../../pages/service-orders/update-service-order-page";
import SearchServiceOrder from "../../pages/service-orders/search-service-order-page";
import { ACCESS_RULES } from "../../shared/auth/access-control";
import RoleProtectedRoute from "../protected/role-protected-route.component";

const ServiceOrderRoutes = () => {
  return (
    <Routes>
      <Route path="/add" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.SERVICE_ORDERS}><CreateServiceOrder /></RoleProtectedRoute>} />
      <Route path="/search" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.SERVICE_ORDERS}><SearchServiceOrder /></RoleProtectedRoute>} />
      <Route path=":serviceOrderId/update" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.SERVICE_ORDERS}><UpdateServiceOrder /></RoleProtectedRoute>} />
    </Routes>
  );
};

export default ServiceOrderRoutes;
